import styles from './index.scss'
import { Toast } from 'antd-mobile'
import React, { useEffect, useRef, useState } from 'react'
import { payList, pay, checkOrderPay, payIntl, createPayIntl } from '@/services'
import Layout from '@/libs/components/Layout'
import iconSelected from '@/assets/image/xuanzhong.png'
import iconUnSelected from '@/assets/image/buxuanzhong.png'
import { getUrlAllParams, getValue } from '@/libs/functions/getValue'
import goTo from '@/libs/functions/goTo'
import { getStorage } from '@/libs/functions/onStorage'
import PaymentModal, { ICardBinInfo } from '@/components/PaymentModal'
import CardBinRadio from '@/components/CardBinRadio'
import getChannelBridgeApi from '@/libs/functions/appAdapter'
import useCategorySet from '@/libs/hooks/useCategorySet'
import { hex2Rgb } from '@/libs/functions/tools'
import { successIcon } from './svgIcon'
import Loading from '@/libs/functions/loading'
import { useModuleLang } from '@/libs/hooks/useLang'

export default function UsableCoupon() {
  const [promptTrans, payTrans] = useModuleLang(['prompt_util', 'pay_util'])
  const {
    orderNo,
    sysSecond = 1799000,
    payAmount,
    backUrl,
  } = getUrlAllParams() as any

  const { categorySetting } = useCategorySet('TENANT', getValue('tenantCode'))
  const { base, buttonStyle } = categorySetting || {}
  const styleSetting = {
    '--primary-color-rgb': hex2Rgb(base?.primaryColor),
    '--primary-color': base?.primaryColor,
    '--primary-background-color': base?.primaryBackgroundColor,
    '--secondary-background-color1': base?.secondaryBackgroundColor1,
    '--secondary-background-color2': base?.secondaryBackgroundColor2,
    '--text-color': base?.textColor,
    '--text-color-rgb': hex2Rgb(base?.textColor || '#9b9b9b'),
    '--button-radius': (buttonStyle?.borderRadius || 0) + 'px',
    '--button-background-color':
      buttonStyle?.backgroundColorType === 'pure'
        ? buttonStyle?.backgroundColor1
        : `linear-gradient(${
            buttonStyle?.backgroundColorType === 'horizontalGradient'
              ? 'to right'
              : 'to bottom'
          }, ${buttonStyle?.backgroundColor1 || '#ffffff'}, ${
            buttonStyle?.backgroundColor2 || '#ffffff'
          })`,
    '--button-text-color': buttonStyle?.textColor,
  }

  const [listData, setListData] = useState<any>([])
  const [selected, setSelected] = useState(0)
  const [cardBinInfo, setCardBinInfo] = useState<any>({
    id: 0,
  })
  const [currencySymbol, setCurrencySymbol] = useState('¥')
  const [timeObj, setTimeObj] = useState<{
    time: number
    minute?: string | number
    second?: string | number
    showCancelTime: boolean
  }>({
    time: sysSecond,
    minute: 29,
    second: 59,
    showCancelTime: true,
  })
  const [loading, setLoading] = useState(true)
  const [payListVisible, setPayListVisible] = useState(false)
  const [cardBinModalVisible, setCardBinModalVisible] = useState(false)
  const channel = getStorage('channel')
  const channelApi = getChannelBridgeApi(channel)
  const hasFetched = useRef(false)

  useEffect(() => {
    if (hasFetched.current) return
    hasFetched.current = true // 标记为已执行

    setLoading(true)
    console.log('channel: ', channel)
    if (channelApi && channelApi.goToPay) {
      channelApi.goToPay({ orderNo })
      if (
        channelApi?.disablePayListSelect &&
        channelApi?.disablePayListSelect()
      ) {
        return
      }
    }

    payList({ orderNo })
      .then(async (res: any) => {
        if (res && res.length > 0) {
          setListData(res)

          const first = res[0] || {}
          if (res.length === 1) {
            // 比如会员小程序，只配一种支付方式且跳去/miniProgramPay，需要隐藏页面
            const paymentHidden =
              channelApi &&
              channelApi.goToPayWithParams &&
              channelApi?.disablePayListSelect &&
              channelApi?.disablePayListSelect()
            if (
              !first.paymentConfigList ||
              (paymentHidden && !first.paymentConfigList)
            ) {
              await onEasyPay(res)
            } else if (
              first.paymentConfigList &&
              !!first.paymentConfigList.length
            ) {
              setPayListVisible(true)
              setCardBinInfo(first.paymentConfigList?.[0])
            }
            return
          }
          setPayListVisible(true)
        } else if (res && res.length === 0) {
          Toast.show({
            content: React.createElement('p', {
              dangerouslySetInnerHTML: {
                __html: payTrans('noAvailablePayType', '暂无可用的支付方式'),
              },
            }),
          })
        }
      })
      .catch((err) => {
        setPayListVisible(true)
      })

    checkOrderPay({ orderNo })
      .then((res: any) => {
        if (res && res.currencySymbol) {
          setCurrencySymbol(res.currencySymbol)
        }
        if (!res.canPay) {
          goTo(`/order/orderRecord?status=`)
          Toast.show({
            content: React.createElement('p', {
              dangerouslySetInnerHTML: {
                __html: payTrans(
                  'payStatusHasChanged',
                  '订单支付状态已发生变更',
                ),
              },
            }),
          })
          return
        }
        setTimeObj({
          time: Number(res.secondsBetween) * 1000,
          showCancelTime: res.showCancelTime,
        })
      })
      .finally(() => {
        setLoading(false)
      })
  }, [payTrans])

  // useEffect(() => {
  //   const first = listData[0] || {}
  //   if (listData.length === 1) {
  //     if (!first.paymentConfigList) {
  //       onEasyPay()
  //     } else if (first.paymentConfigList && !!first.paymentConfigList.length) {
  //       setCardBinInfo(first.paymentConfigList?.[0])
  //     }
  //     return
  //   }
  // }, [listData])

  useEffect(() => {
    const { time } = timeObj
    const _time = time - 1000
    const timer = setTimeout(() => {
      if (time > 0) {
        const second = Math.floor((_time / 1000) % 60)
        const minute = Math.floor(_time / 1000 / 60)
        setTimeObj({
          ...timeObj,
          time: _time,
          minute: minute < 10 ? '0' + minute : minute,
          second: second < 10 ? '0' + second : second,
        })
        return
      }
      goTo(`/order/orderRecord?status=`)
    }, 1000)
    return () => {
      clearTimeout(timer)
    }
  }, [timeObj.time])

  useEffect(() => {
    window?.dpTracker?.sendPage({
      publicParams: {
        page_name: '收银台',
        order_id: orderNo,
      },
    })
    return () => {
      window?.dpTracker?.sendPageEnd()
    }
  }, [])

  const reportPayClk = (
    module_name: string,
    component_name: string,
    extra?: { [key: string]: any },
  ) => {
    window?.dpTracker?.sendClk({
      eventData: {
        order_id: orderNo,
        module_name,
        component_name,
        ...(extra || {}),
      },
    })
  }

  // 普通支付
  const onEasyPay = async (customerListData?: any) => {
    const payTypeObj = (customerListData || listData)[selected]
    const { code } = payTypeObj || {}
    const param = {
      payType: code,
      orderNo,
      url: getBackUrl(),
    }

    await callPay(param)
  }

  const callPay = async (
    param: {
      payType: string
      orderNo: string
      configId?: string
      cardNo?: string
      url?: string
    } & PartialSome<
      ICardBinInfo,
      'cardNumber' | 'cvv' | 'expireTime' | 'cardHolderName'
    >,
    code?: string,
  ) => {
    setLoading(true)
    Loading.show()

    // 国际支付
    if (code && code === 'overseas') {
      try {
        const res = (await createPayIntl({
          cvv: param.cvv,
          cardNumber: param.cardNumber,
          cardHolderName: param.cardHolderName,
          expireTime: param.expireTime,
        })) as { token: string }
        console.log('data: ', res)
        if (res && res?.token) {
          const redirectUrl = getBackUrl()
          const { width, height, colorDepth } = screen
          const { isFinish, payUrl } = await payIntl({
            token: res?.token,
            orderNo,
            redirectUrl,
            configId: param.configId || '',
            deviceInfo: {
              screenWidth: width,
              screenHeight: height,
              innerHeight: window.innerHeight,
              innerWidth: window.innerWidth,
              colorDepth,
            },
          })
          if (!isFinish && payUrl) {
            window.location.replace(payUrl)
          } else {
            const separator = redirectUrl.includes('?') ? '&' : '?'
            window.location.replace(`${redirectUrl}${separator}status=success`)
          }
        }
      } finally {
        setLoading(false)
        Loading.hide()
        setCardBinModalVisible(false)
      }
      return
    }

    delete param.cardHolderName
    delete param.cardNumber
    delete param.cvv
    delete param.expireTime
    return pay(param)
      .then((res: any) => {
        const { url } = res
        if (code === 'alipay') {
          goTo(url)
        } else {
          window.location.replace(url)
        }
      })
      .catch((e) => {
        Toast.show({
          content: React.createElement('p', {
            dangerouslySetInnerHTML: {
              __html:
                e.msg ||
                promptTrans('requestErrorText2', '服务繁忙，请稍后再试~'),
            },
          }),
        })
        if (e.errCode === '-22') {
          goTo(`/order/orderRecord?status=`)
        }
      })
      .finally(() => {
        setLoading(false)
        setCardBinModalVisible(false)
      })
  }

  const getBackUrl = () => {
    const _backUrl = decodeURIComponent(backUrl || '') || `/result`
    const hasHttp = _backUrl.startsWith('http')
    const isNeedBrowerSkip = _backUrl.startsWith('weixin')
    if (!hasHttp && !isNeedBrowerSkip) {
      return `${window.location.origin}/#${
        _backUrl.indexOf('?') > -1 && _backUrl.indexOf('orderNo') > -1
          ? _backUrl
          : _backUrl.indexOf('?') > -1
          ? `${_backUrl}&orderNo=${orderNo}`
          : `${_backUrl}?orderNo=${orderNo}`
      }`
    } else {
      return _backUrl
    }
  }

  // 卡bin支付
  const onPayWithCardBin = async (cardBinValues: ICardBinInfo) => {
    const { cardNumber } = cardBinValues

    const payTypeObj = listData[selected]
    const { code } = payTypeObj || {}
    const param = {
      payType: code,
      orderNo,
      configId: cardBinInfo?.id || '',
      cardNo: cardNumber,
      url: getBackUrl(),
      ...cardBinValues,
    }

    callPay(param, code)
  }

  const handlePayBtnClick = () => {
    const payTypeObj = listData[selected]
    const { paymentConfigList = [], name } = payTypeObj || {}
    reportPayClk('支付按钮', '确认支付', {
      payment_channel: name,
    })
    if (paymentConfigList && !!paymentConfigList.length) {
      if (!cardBinInfo || !cardBinInfo.id) {
        Toast.show({
          content: payTrans('selectCardBINType', '请先选择卡bin方式'),
        })
        return
      }
      // 填写卡bin信息
      setCardBinModalVisible(true)
    } else {
      onEasyPay()
    }
  }

  return (
    <Layout
      title={payTrans('paymentCheckout', '支付收银台')}
      onBack={() => {
        goTo(`/order/orderRecord`)
      }}
      style={styleSetting}
      navBarStyle={{
        background: `var(--primary-background-color)`,
        color: `var(--text-color)`,
      }}
    >
      {!loading && payListVisible && (
        <div className={styles.payPage}>
          <div className={styles.payPriceTitle} style={{ textAlign: 'center' }}>
            {payTrans('payAmount', '支付金额')}
          </div>
          <div className={styles.payPrice}>
            <span className={styles.payUnit}>{currencySymbol}</span>
            {payAmount}
          </div>
          {timeObj.showCancelTime && listData.length > 0 && (
            <div className={styles.payTime}>
              {payTrans('payTimeRemain', '支付剩余时间')}{' '}
              <span className={styles.time}>
                {timeObj.minute || '--'}：{timeObj.second || '--'}
              </span>
            </div>
          )}
          <div className={styles.listContent}>
            <div className={styles.title}>
              {listData.length > 0
                ? payTrans('selectPayType', '选择支付方式')
                : payTrans('noAvailablePayType', '暂无可用的支付方式')}
            </div>
            <div>
              {listData.length > 0 &&
                listData.map((listItem: any, index: number) => (
                  <div className={styles.list}>
                    <div
                      className={`${styles.listItem} ${
                        listItem.paymentConfigList && index === selected
                          ? styles.listItemNoBorder
                          : ''
                      }`}
                      onClick={() => {
                        reportPayClk('支付渠道', '选择渠道', {
                          payment_channel: listData[index]?.name,
                        })
                        setSelected(index)
                        if (
                          listItem.paymentConfigList &&
                          !!listItem.paymentConfigList.length
                        ) {
                          setCardBinInfo(listItem.paymentConfigList?.[0])
                        }
                      }}
                    >
                      <img src={listItem.logo} className={styles.icon} />
                      <div className={`${styles.text} ${styles.title}`}>
                        {listItem.name}
                      </div>
                      {index !== selected ? (
                        <i
                          // src={iconUnSelected}
                          className={styles.selectIcon}
                        />
                      ) : (
                        <i
                          className={`${styles.selectIcon} ${styles.selectIconActive}`}
                          dangerouslySetInnerHTML={{ __html: successIcon }}
                        ></i>
                      )}
                    </div>
                    {listItem.paymentConfigList && index === selected && (
                      <CardBinRadio
                        style={styleSetting}
                        className={styles.carBinRadioWrap}
                        value={cardBinInfo?.id}
                        options={listItem.paymentConfigList}
                        onChange={(_, item) => {
                          reportPayClk('银行卡号', '选择卡号', {
                            payment_channel: item?.title,
                          })
                          setCardBinInfo(item)
                        }}
                      />
                    )}
                  </div>
                ))}
            </div>
          </div>
          {listData.length > 0 && (
            <div className={styles.bottomBtn}>
              <div className={styles.button} onClick={handlePayBtnClick}>
                {payTrans('confirmToPay', '确认支付')}
              </div>
            </div>
          )}
        </div>
      )}
      <PaymentModal
        code={listData[selected]?.code ?? ''}
        cardBinInfo={cardBinInfo}
        payAmount={payAmount}
        payTypeLogo={listData[selected]?.logo ?? ''}
        payTypeName={listData[selected]?.name ?? ''}
        visible={cardBinModalVisible}
        onCancel={() => setCardBinModalVisible(false)}
        onOk={(cardInfo) => {
          reportPayClk('卡号弹出框', '确认支付')
          onPayWithCardBin(cardInfo)
        }}
        currencySymbol={currencySymbol}
      />
    </Layout>
  )
}
